import { useFormContext } from 'react-hook-form';
import { FormInputField, FormSwitchField, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Stack } from '@optimus-web/core';
import { LocalizedMinorHighlight, LocalizedSubsectionTitle } from '@mews-commander/ui';
import { useIsNonRegionalCreditNoteCounterEnabled } from '../../helpers';
import { CounterFormField, CounterFormValues } from './formMapping';

export const CounterFormBillCounterSettings = () => {
    const { formState, watch } = useFormContext<CounterFormValues>();
    const creditNoteEnabled = useIsNonRegionalCreditNoteCounterEnabled();
    const isAlreadyDefault = formState.defaultValues?.isDefault === true;
    const isDefaultToggled = watch(CounterFormField.IsDefault, formState.defaultValues?.isDefault);
    const showCreditNoteInput = creditNoteEnabled && isDefaultToggled;

    const defaultToggleTitle = creditNoteEnabled
        ? TextKey.FlexibleCorrectionsCreditNotesDefaultToggleTitle
        : TextKey.UseBillCounterAsDefault;

    const defaultToggleHelper = creditNoteEnabled
        ? TextKey.FlexibleCorrectionsCreditNotesDefaultToggleDescription
        : TextKey.UseBillCounterAsDefaultHelper;

    return (
        <Stack distribution="stretch" vertical spacing="300">
            <LocalizedSubsectionTitle textKey={TextKey.CounterTypeSettings} />

            {creditNoteEnabled ? (
                <Banner
                    variant="info"
                    primaryText={lt('FlexibleCorrectionsCreditNotesBannerTitle')}
                    secondaryText={lt('FlexibleCorrectionsCreditNotesBannerDescription')}
                />
            ) : null}

            <LocalizedMinorHighlight textKey={TextKey.BillCounter} />

            <FormSwitchField
                helper={lt(defaultToggleHelper)}
                label={lt(defaultToggleTitle)}
                name={CounterFormField.IsDefault}
                disabled={isAlreadyDefault}
            />

            <FormInputField
                helper={lt('BillCounterTitleHelper')}
                placeholder={lt('BillCounterTitlePlaceholder')}
                label={lt('BillCounterTitle')}
                name={CounterFormField.Title}
                size="medium"
            />

            {showCreditNoteInput ? (
                <FormInputField
                    helper={lt('CreditNoteBillCounterHelper')}
                    placeholder={lt('CreditNoteBillCounterPlaceholder')}
                    label={lt('CreditNoteBillCounter')}
                    name={CounterFormField.CreditNoteTitle}
                    required
                />
            ) : null}
        </Stack>
    );
};
